import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {

    override parse(url: string): UrlTree {
        return super.parse(url.replace(/\/$/, ''));
    }

}
